import i18next from 'i18next'

/**
 * Get the locale string for date formatting based on current i18n language
 */
export const getDateLocale = (): string => {
  const lang = i18next.language || 'fr'
  if (lang.startsWith('fr')) return 'fr-CH'
  if (lang.startsWith('de')) return 'de-CH'
  if (lang.startsWith('it')) return 'it-CH'
  if (lang.startsWith('en')) return 'en-GB'
  return 'fr-CH'
}

/**
 * Format a number with Swiss thousand separators (')
 */
export const formatSwissNumber = (num: number): string => {
  // Convert to string and split on decimal point if present
  const parts = num.toString().split('.')
  // Add Swiss thousand separators to the integer part
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, "'")
  // Join back with decimal point if there was a decimal part
  return parts.join('.')
}

/**
 * Format price in CHF with Swiss thousand separators
 */
export const formatSwissPrice = (price: number): string => {
  return `CHF ${formatSwissNumber(price)}`
}

/**
 * Format price per square meter with Swiss thousand separators
 */
export const formatSwissPricePerSqm = (price: number): string => {
  return `CHF ${formatSwissNumber(price)}/m²`
}

/**
 * Truncate text to a maximum length and add ellipsis if needed
 */
export const truncateText = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}
